import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Loading, TitleController } from '@pandiafi/design-system'

import { DataLoader } from './DocumentsDataLoader'
import { DocumentCategoryInfo } from './DocumentCategoryInfo'
import { ErrorHandler } from './DocumentsErrorHandler'

import { Error, View } from 'components'
import { useContractPaths } from 'hooks/useContractPaths/useContractPaths'

export const Documents: React.FC = () => {
  const { t } = useTranslation(['common', 'titles', 'documents'])
  const { frontPagePath } = useContractPaths()

  return (
    <TitleController title={t('titles:documents')}>
      <View>
        <View.Header>
          <View.HeaderLink to={frontPagePath}>
            {t('common:views.home')}
          </View.HeaderLink>

          <View.HeaderTitle>{t('common:views.documents')}</View.HeaderTitle>
        </View.Header>

        <View.Sidebar />

        <View.Content>
          <Suspense fallback={<Loading variant="details" />}>
            <ErrorHandler>
              <DataLoader>
                {({ data }) => {
                  if (!data.length) {
                    return (
                      <Error
                        illustration="box-empty"
                        message={t('documents:errors.noDocuments')}
                      />
                    )
                  }

                  return data.map(({ category, documents }) => (
                    <DocumentCategoryInfo
                      key={category.id}
                      category={category}
                      docs={documents}
                    />
                  ))
                }}
              </DataLoader>
            </ErrorHandler>
          </Suspense>
        </View.Content>
      </View>
    </TitleController>
  )
}
